import { css } from 'styled-components';

export const manualPadding = css`
  ${({ theme }) => `
    padding-right: ${theme.screenSize.s380.gridHorizontalPadding}rem;
    padding-left: ${theme.screenSize.s380.gridHorizontalPadding}rem;
    ${theme.screenSize.s576.mediaQuery} {
      padding-right: ${theme.screenSize.s576.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s576.gridHorizontalPadding}rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      padding-right: ${theme.screenSize.s768.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s768.gridHorizontalPadding}rem;
    }
    ${theme.screenSize.s992.mediaQuery} {
      padding-right: ${theme.screenSize.s992.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s992.gridHorizontalPadding}rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      padding-right: ${theme.screenSize.s1024.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s1024.gridHorizontalPadding}rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      padding-right: ${theme.screenSize.s1200.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s1200.gridHorizontalPadding}rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      padding-right: ${theme.screenSize.s1366.gridHorizontalPadding}rem;
      padding-left: ${theme.screenSize.s1366.gridHorizontalPadding}rem;
    }
  `}
`;
